import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import '../styles/TransferForm.css';
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import { RotatingLines, Rings, Oval } from "react-loader-spinner";
import {loginAccount} from '../requests/requests'
import GoogleIcon   from "../assets/other/google.svg";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const LoginTransferForm = () => {

  //const navigate = useNavigate();
  const [googleClientId, setGoogleClientId] = useState('749296163786-c75bu38p9kn80o79fcqs5serd36tsn8k.apps.googleusercontent.com');
  const [formLoading, setFormLoading] = useState(false);
  const [formGoogleLoading, setGoogleFormLoading] = useState(false);
  const [authToken, setAuthToken] = useState("");
  const [componentData, setComponentData] = useState({
                                                                  currencyOptions: [],
                                                                  buyCurrencyFilter: [],
                                                                  sellCurrencyFilter: [],
                                                                  currencyCountryFlagsCollection: [],
                                                                  data: {
                                                                    email: "",
                                                                    password: ""
                                                                  }
                                                              });    
  
  const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm();

	const login = useMutation({
		mutationFn: (creds) => {
      setFormLoading(true);
      return loginAccount(creds);
		},
		onError: (error, variables, context) => {
      
      setFormLoading(false);
			const errors = error.response.data.errors;
			const emailNotConfirmed = _.find(errors, ["title", "Email not confirmed"]);

			if (!_.isEmpty(emailNotConfirmed)) {
				const email = variables.email;
				navigate(`/confirm/email?email=${encodeURIComponent(email)}`);
			}
		},
		onSuccess: (data, variables, context) => {

      setFormLoading(false);
			const authTokens = data?.data;
			localStorage.setItem("authToken", JSON.stringify(authTokens));
			setAuthToken(authTokens);

		},
	});
  
	const onUserLogin = (creds) => {
		login.mutate(creds);
	};

  const contentChange= (e, theKey, trimSpace = false) => {
    try{
      
      let { value } = e.target;
      if(trimSpace){
            value = value.trim().replace(/\s+/g, '');
      }
      setComponentData((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [theKey]: value,
        },
      }));

    } catch(e){
      console.log(e)
    }
  }
  

  // Custom option label with image and text
  const formatOptionLabel = ({ label, imageUrl }) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={imageUrl} alt={label} style={{ width: 20, height: 20, marginRight: 10 }} />
        <span>{label}</span>
      </div>
  );

  const onUserGoogleLogin = () => {
        
  }

  const handleLoginSuccess = (e) => {
    console.log('success', e)  
  }

  const handleLoginFailure = (e) => {
    console.log('error', e)  
  }

  return (
    <div className="card-login">
      <form className="form">

        <div className="text-center-content">
           <h3 className="text-center">Log into Your PeerPesa Account</h3> 
        </div>   
        <div className="form-inputs">
          <label> Email  </label>
          <div className="selection-payment-method clearfix group">
            <input type="text"
                   value={componentData.data.email}
                   className="selection-other"
                   placeholder="Enter your email"
							     name="email"
                   {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                   })}
                   onChange={(e) => contentChange(e, 'email', true)} />
          </div>
          {errors.email?.type === "required" && (<span className="main-input-error">
            {errors.email.message}
          </span>)}
          {errors.email?.type === "pattern" && (<span className="main-input-error">
            {errors.email.message}
          </span>)}
        </div>
        <div className="form-inputs">
          <label> Password </label>
          <div className="selection-payment-method clearfix group">
            <input type="password" 
                   value={componentData.data.password} 
                   className="selection-other"  
                   placeholder="Enter your password"
                   {...register("password", { required: true })} 
                   onChange={(e) => contentChange(e, 'password')}

                   />
          </div>
          {errors.password?.type === "required" && (
								<span className="main-input-error">
									{/* <Info className="login_input_error_icon" /> */}
                  Password is required
								</span>
						  )} 
        </div>

        <div className="text-center-content-2">
           <p className="text-left">
              Forgot password? <Link to="/reset-password" className="nav-link">Reset it here</Link>
           </p> 
        </div>

        
        <button className="send-button" onClick={handleSubmit(onUserLogin)}>
           <span  className={(formLoading)? 'hidden':''}>Login</span>
           <Oval
                          visible={formLoading}
                          height="20"
                          width="20"
                          color="#ffffff"
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          />                        
        </button>

        
        <div className="text-center-content-200">
          <p className="text-center">
            or
          </p> 
        </div>

        <GoogleOAuthProvider clientId={googleClientId}>
          <GoogleLogin
                        theme="filled_black"
                        size="medium"
                        shape="circle" 
                        onSuccess={handleLoginSuccess}
                        onError={handleLoginFailure} />
        </GoogleOAuthProvider>

        {/* <button className="login-button" onClick={handleSubmit(onUserGoogleLogin)}>
            <img src={GoogleIcon} alt="google login" className={(formGoogleLoading)? 'hidden':'google-login'} />
            <span  className={(formGoogleLoading)? 'hidden':''}>Login with Google</span>
            <Oval
                          visible={formGoogleLoading}
                          height="20"
                          width="20"
                          color="#ffffff"
                          ariaLabel="oval-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          />                        
        </button> */}

        <div className="text-center-content-2">
           <p className="text-center">
             Dont Have An Account? <Link to="/register" className="nav-link">Signup here</Link> 
           </p> 
        </div>


        
        <div className="text-center-content-2">
           <p className="text-center">
               &copy; PeerPesa 2024 All Rights Reserved
           </p> 
        </div>
      
        {/* 
           <RotatingLines
                          strokeColor="#ffffff"
                          strokeWidth="5"
                          animationDuration="0.75"
                          width="20"
                          visible={true}
                        />
           <Rings
                          visible={true}
                          height="40"
                          width="40"
                          color="#ffffff"
                          ariaLabel="rings-loading"
                          wrapperStyle={{}}
                          wrapperClass=""
                          /> 
        */}

        
      </form>
    </div>
  );
};

export default LoginTransferForm;
